// extracted by mini-css-extract-plugin
export default {"banner_text":"Banner_banner_text__isiI8","bg_img":"Banner_bg_img__-NTn7","bg_color":"Banner_bg_color__SqyEP"};